export const icon_data = [
  {
    "group": "方向性图标",
    "icons": [
      {
        "value": "StepBackwardOutlined",
        "name": "后退一步"
      },
      {
        "value": "StepForwardOutlined",
        "name": "前进一步"
      },
      {
        "value": "FastBackwardOutlined",
        "name": "快速后退"
      },
      {
        "value": "FastForwardOutlined",
        "name": "快速前进"
      },
      {
        "value": "ShrinkOutlined",
        "name": "缩小"
      },
      {
        "value": "ArrowsAltOutlined",
        "name": "箭头"
      },
      {
        "value": "DownOutlined",
        "name": "向下"
      },
      {
        "value": "UpOutlined",
        "name": "向上"
      },
      {
        "value": "LeftOutlined",
        "name": "向左"
      },
      {
        "value": "RightOutlined",
        "name": "向右"
      },
      {
        "value": "CaretUpOutlined",
        "name": "上箭头"
      },
      {
        "value": "CaretDownOutlined",
        "name": "下箭头"
      },
      {
        "value": "CaretLeftOutlined",
        "name": "左箭头"
      },
      {
        "value": "CaretRightOutlined",
        "name": "右箭头"
      },
      {
        "value": "UpCircleOutlined",
        "name": "圆形上箭头"
      },
      {
        "value": "DownCircleOutlined",
        "name": "圆形下箭头"
      },
      {
        "value": "LeftCircleOutlined",
        "name": "圆形左箭头"
      },
      {
        "value": "RightCircleOutlined",
        "name": "圆形右箭头"
      },
      {
        "value": "DoubleRightOutlined",
        "name": "双右箭头"
      },
      {
        "value": "DoubleLeftOutlined",
        "name": "双左箭头"
      },
      {
        "value": "VerticalLeftOutlined",
        "name": "垂直左箭头"
      },
      {
        "value": "VerticalRightOutlined",
        "name": "垂直右箭头"
      },
      {
        "value": "VerticalAlignTopOutlined",
        "name": "顶部对齐"
      },
      {
        "value": "VerticalAlignMiddleOutlined",
        "name": "垂直居中"
      },
      {
        "value": "VerticalAlignBottomOutlined",
        "name": "底部对齐"
      },
      {
        "value": "ForwardOutlined",
        "name": "前进"
      },
      {
        "value": "BackwardOutlined",
        "name": "后退"
      },
      {
        "value": "RollbackOutlined",
        "name": "回滚"
      },
      {
        "value": "EnterOutlined",
        "name": "回车"
      },
      {
        "value": "RetweetOutlined",
        "name": "重新发送"
      },
      {
        "value": "SwapOutlined",
        "name": "交换"
      },
      {
        "value": "SwapLeftOutlined",
        "name": "向左交换"
      },
      {
        "value": "SwapRightOutlined",
        "name": "向右交换"
      },
      {
        "value": "ArrowUpOutlined",
        "name": "上箭头"
      },
      {
        "value": "ArrowDownOutlined",
        "name": "下箭头"
      },
      {
        "value": "ArrowLeftOutlined",
        "name": "左箭头"
      },
      {
        "value": "ArrowRightOutlined",
        "name": "右箭头"
      },
      {
        "value": "PlayCircleOutlined",
        "name": "播放"
      },
      {
        "value": "UpSquareOutlined",
        "name": "方形上箭头"
      },
      {
        "value": "DownSquareOutlined",
        "name": "方形下箭头"
      },
      {
        "value": "LeftSquareOutlined",
        "name": "方形左箭头"
      },
      {
        "value": "RightSquareOutlined",
        "name": "方形右箭头"
      },
      {
        "value": "LoginOutlined",
        "name": "登录"
      },
      {
        "value": "LogoutOutlined",
        "name": "登出"
      },
      {
        "value": "MenuFoldOutlined",
        "name": "菜单折叠"
      },
      {
        "value": "MenuUnfoldOutlined",
        "name": "菜单展开"
      },
      {
        "value": "BorderBottomOutlined",
        "name": "下边框"
      },
      {
        "value": "BorderHorizontalOutlined",
        "name": "水平边框"
      },
      {
        "value": "BorderInnerOutlined",
        "name": "内边框"
      },
      {
        "value": "BorderOuterOutlined",
        "name": "外边框"
      },
      {
        "value": "BorderLeftOutlined",
        "name": "左边框"
      },
      {
        "value": "BorderRightOutlined",
        "name": "右边框"
      },
      {
        "value": "BorderTopOutlined",
        "name": "上边框"
      },
      {
        "value": "BorderVerticleOutlined",
        "name": "垂直边框"
      },
      {
        "value": "PicCenterOutlined",
        "name": "图片居中"
      },
      {
        "value": "PicLeftOutlined",
        "name": "图片居左"
      },
      {
        "value": "PicRightOutlined",
        "name": "图片居右"
      },
      {
        "value": "RadiusBottomleftOutlined",
        "name": "左下圆角"
      },
      {
        "value": "RadiusBottomrightOutlined",
        "name": "右下圆角"
      },
      {
        "value": "RadiusUpleftOutlined",
        "name": "左上圆角"
      },
      {
        "value": "RadiusUprightOutlined",
        "name": "右上圆角"
      },
      {
        "value": "FullscreenOutlined",
        "name": "全屏"
      },
      {
        "value": "FullscreenExitOutlined",
        "name": "退出全屏"
      }
    ]
  },
  {
    "group": "提示建议性图标",
    "icons": [
      {
        "value": "QuestionOutlined",
        "name": "问号"
      },
      {
        "value": "QuestionCircleOutlined",
        "name": "圆形问号"
      },
      {
        "value": "PlusOutlined",
        "name": "加号"
      },
      {
        "value": "PlusCircleOutlined",
        "name": "圆形加号"
      },
      {
        "value": "PauseOutlined",
        "name": "暂停"
      },
      {
        "value": "PauseCircleOutlined",
        "name": "圆形暂停"
      },
      {
        "value": "MinusOutlined",
        "name": "减号"
      },
      {
        "value": "MinusCircleOutlined",
        "name": "圆形减号"
      },
      {
        "value": "PlusSquareOutlined",
        "name": "方形加号"
      },
      {
        "value": "MinusSquareOutlined",
        "name": "方形减号"
      },
      {
        "value": "InfoOutlined",
        "name": "信息"
      },
      {
        "value": "InfoCircleOutlined",
        "name": "圆形信息"
      },
      {
        "value": "ExclamationOutlined",
        "name": "感叹号"
      },
      {
        "value": "ExclamationCircleOutlined",
        "name": "圆形感叹号"
      },
      {
        "value": "CloseOutlined",
        "name": "关闭"
      },
      {
        "value": "CloseCircleOutlined",
        "name": "圆形关闭"
      },
      {
        "value": "CloseSquareOutlined",
        "name": "方形关闭"
      },
      {
        "value": "CheckOutlined",
        "name": "勾选"
      },
      {
        "value": "CheckCircleOutlined",
        "name": "圆形勾选"
      },
      {
        "value": "CheckSquareOutlined",
        "name": "方形勾选"
      },
      {
        "value": "ClockCircleOutlined",
        "name": "时钟"
      },
      {
        "value": "WarningOutlined",
        "name": "警告"
      },
      {
        "value": "IssuesCloseOutlined",
        "name": "问题关闭"
      },
      {
        "value": "StopOutlined",
        "name": "停止"
      }
    ]
  },
  {
    "group": "编辑类图标",
    "icons": [
      {
        "value": "EditOutlined",
        "name": "编辑"
      },
      {
        "value": "FormOutlined",
        "name": "表单"
      },
      {
        "value": "CopyOutlined",
        "name": "复制"
      },
      {
        "value": "ScissorOutlined",
        "name": "剪刀"
      },
      {
        "value": "DeleteOutlined",
        "name": "删除"
      },
      {
        "value": "SnippetsOutlined",
        "name": "代码片段"
      },
      {
        "value": "DiffOutlined",
        "name": "差异"
      },
      {
        "value": "HighlightOutlined",
        "name": "高亮"
      },
      {
        "value": "AlignCenterOutlined",
        "name": "居中对齐"
      },
      {
        "value": "AlignLeftOutlined",
        "name": "左对齐"
      },
      {
        "value": "AlignRightOutlined",
        "name": "右对齐"
      },
      {
        "value": "BgColorsOutlined",
        "name": "背景色"
      },
      {
        "value": "BoldOutlined",
        "name": "加粗"
      },
      {
        "value": "ItalicOutlined",
        "name": "斜体"
      },
      {
        "value": "UnderlineOutlined",
        "name": "下划线"
      },
      {
        "value": "StrikethroughOutlined",
        "name": "删除线"
      },
      {
        "value": "RedoOutlined",
        "name": "重做"
      },
      {
        "value": "UndoOutlined",
        "name": "撤销"
      },
      {
        "value": "ZoomInOutlined",
        "name": "放大"
      },
      {
        "value": "ZoomOutOutlined",
        "name": "缩小"
      },
      {
        "value": "FontColorsOutlined",
        "name": "字体颜色"
      },
      {
        "value": "FontSizeOutlined",
        "name": "字体大小"
      },
      {
        "value": "LineHeightOutlined",
        "name": "行高"
      },
      {
        "value": "DashOutlined",
        "name": "虚线"
      },
      {
        "value": "SmallDashOutlined",
        "name": "小虚线"
      },
      {
        "value": "SortAscendingOutlined",
        "name": "升序"
      },
      {
        "value": "SortDescendingOutlined",
        "name": "降序"
      },
      {
        "value": "DragOutlined",
        "name": "拖拽"
      },
      {
        "value": "OrderedListOutlined",
        "name": "有序列表"
      },
      {
        "value": "UnorderedListOutlined",
        "name": "无序列表"
      },
      {
        "value": "RadiusSettingOutlined",
        "name": "圆角设置"
      },
      {
        "value": "ColumnWidthOutlined",
        "name": "列宽"
      },
      {
        "value": "ColumnHeightOutlined",
        "name": "列高"
      }
    ]
  },
  {
    "group": "数据类图标",
    "icons": [
      {
        "value": "AreaChartOutlined",
        "name": "区域图"
      },
      {
        "value": "PieChartOutlined",
        "name": "饼图"
      },
      {
        "value": "BarChartOutlined",
        "name": "柱状图"
      },
      {
        "value": "DotChartOutlined",
        "name": "点图"
      },
      {
        "value": "LineChartOutlined",
        "name": "折线图"
      },
      {
        "value": "RadarChartOutlined",
        "name": "雷达图"
      },
      {
        "value": "HeatMapOutlined",
        "name": "热力图"
      },
      {
        "value": "FallOutlined",
        "name": "下降"
      },
      {
        "value": "RiseOutlined",
        "name": "上升"
      },
      {
        "value": "StockOutlined",
        "name": "股票"
      },
      {
        "value": "BoxPlotOutlined",
        "name": "箱型图"
      },
      {
        "value": "FundOutlined",
        "name": "基金"
      },
      {
        "value": "SlidersOutlined",
        "name": "滑动条"
      }
    ]
  },
  {
    "group": "品牌和标识",
    "icons": [
      {
        "value": "AndroidOutlined",
        "name": "安卓"
      },
      {
        "value": "AppleOutlined",
        "name": "苹果"
      },
      {
        "value": "WindowsOutlined",
        "name": "Windows"
      },
      {
        "value": "IeOutlined",
        "name": "IE浏览器"
      },
      {
        "value": "ChromeOutlined",
        "name": "Chrome浏览器"
      },
      {
        "value": "GithubOutlined",
        "name": "GitHub"
      },
      {
        "value": "AliwangwangOutlined",
        "name": "阿里旺旺"
      },
      {
        "value": "DingdingOutlined",
        "name": "钉钉"
      },
      {
        "value": "WeiboSquareOutlined",
        "name": "方形微博"
      },
      {
        "value": "WeiboCircleOutlined",
        "name": "圆形微博"
      },
      {
        "value": "TaobaoCircleOutlined",
        "name": "圆形淘宝"
      },
      {
        "value": "Html5Outlined",
        "name": "HTML5"
      },
      {
        "value": "WeiboOutlined",
        "name": "微博"
      },
      {
        "value": "TwitterOutlined",
        "name": "推特"
      },
      {
        "value": "WechatOutlined",
        "name": "微信"
      },
      {
        "value": "YoutubeOutlined",
        "name": "YouTube"
      },
      {
        "value": "AlipayCircleOutlined",
        "name": "圆形支付宝"
      },
      {
        "value": "TaobaoOutlined",
        "name": "淘宝"
      },
      {
        "value": "SkypeOutlined",
        "name": "Skype"
      },
      {
        "value": "QqOutlined",
        "name": "QQ"
      },
      {
        "value": "MediumWorkmarkOutlined",
        "name": "Medium工作标记"
      },
      {
        "value": "GitlabOutlined",
        "name": "GitLab"
      },
      {
        "value": "MediumOutlined",
        "name": "Medium"
      },
      {
        "value": "LinkedinOutlined",
        "name": "领英"
      },
      {
        "value": "GooglePlusOutlined",
        "name": "Google+"
      },
      {
        "value": "DropboxOutlined",
        "name": "Dropbox"
      },
      {
        "value": "FacebookOutlined",
        "name": "脸书"
      },
      {
        "value": "CodepenOutlined",
        "name": "CodePen"
      },
      {
        "value": "CodeSandboxOutlined",
        "name": "CodeSandbox"
      },
      {
        "value": "AmazonOutlined",
        "name": "亚马逊"
      },
      {
        "value": "GoogleOutlined",
        "name": "谷歌"
      },
      {
        "value": "CodepenCircleOutlined",
        "name": "圆形CodePen"
      },
      {
        "value": "AlipayOutlined",
        "name": "支付宝"
      },
      {
        "value": "AntDesignOutlined",
        "name": "Ant Design"
      },
      {
        "value": "AntCloudOutlined",
        "name": "蚂蚁云"
      },
      {
        "value": "AliyunOutlined",
        "name": "阿里云"
      },
      {
        "value": "ZhihuOutlined",
        "name": "知乎"
      },
      {
        "value": "SlackOutlined",
        "name": "Slack"
      },
      {
        "value": "SlackSquareOutlined",
        "name": "方形Slack"
      },
      {
        "value": "BehanceOutlined",
        "name": "Behance"
      },
      {
        "value": "BehanceSquareOutlined",
        "name": "方形Behance"
      },
      {
        "value": "DribbbleOutlined",
        "name": "Dribbble"
      },
      {
        "value": "DribbbleSquareOutlined",
        "name": "方形Dribbble"
      },
      {
        "value": "InstagramOutlined",
        "name": "Instagram"
      },
      {
        "value": "YuqueOutlined",
        "name": "语雀"
      },
      {
        "value": "AlibabaOutlined",
        "name": "阿里巴巴"
      },
      {
        "value": "YahooOutlined",
        "name": "雅虎"
      },
      {
        "value": "RedditOutlined",
        "name": "Reddit"
      },
      {
        "value": "SketchOutlined",
        "name": "Sketch"
      }
    ]
  },
  {
    "group": "网站通用图标",
    "icons": [
      {
        "value": "AccountBookOutlined",
        "name": "记账本"
      },
      {
        "value": "AimOutlined",
        "name": "目标"
      },
      {
        "value": "AlertOutlined",
        "name": "警告"
      },
      {
        "value": "ApartmentOutlined",
        "name": "公寓"
      },
      {
        "value": "ApiOutlined",
        "name": "接口"
      },
      {
        "value": "AppstoreAddOutlined",
        "name": "应用商店添加"
      },
      {
        "value": "AppstoreOutlined",
        "name": "应用商店"
      },
      {
        "value": "AudioOutlined",
        "name": "音频"
      },
      {
        "value": "AudioMutedOutlined",
        "name": "静音"
      },
      {
        "value": "AuditOutlined",
        "name": "审核"
      },
      {
        "value": "BankOutlined",
        "name": "银行"
      },
      {
        "value": "BarcodeOutlined",
        "name": "条形码"
      },
      {
        "value": "BarsOutlined",
        "name": "柱状"
      },
      {
        "value": "BellOutlined",
        "name": "铃铛"
      },
      {
        "value": "BlockOutlined",
        "name": "阻止"
      },
      {
        "value": "BookOutlined",
        "name": "书本"
      },
      {
        "value": "BorderOutlined",
        "name": "边框"
      },
      {
        "value": "BorderlessTableOutlined",
        "name": "无边框表格"
      },
      {
        "value": "BranchesOutlined",
        "name": "分支"
      },
      {
        "value": "BugOutlined",
        "name": "错误"
      },
      {
        "value": "BuildOutlined",
        "name": "构建"
      },
      {
        "value": "BulbOutlined",
        "name": "灯泡"
      },
      {
        "value": "CalculatorOutlined",
        "name": "计算器"
      },
      {
        "value": "CalendarOutlined",
        "name": "日历"
      },
      {
        "value": "CameraOutlined",
        "name": "相机"
      },
      {
        "value": "CarOutlined",
        "name": "汽车"
      },
      {
        "value": "CarryOutOutlined",
        "name": "执行"
      },
      {
        "value": "CiCircleOutlined",
        "name": "圆形CI"
      },
      {
        "value": "CiOutlined",
        "name": "CI"
      },
      {
        "value": "ClearOutlined",
        "name": "清除"
      },
      {
        "value": "CloudDownloadOutlined",
        "name": "云下载"
      },
      {
        "value": "CloudOutlined",
        "name": "云"
      },
      {
        "value": "CloudServerOutlined",
        "name": "云服务器"
      },
      {
        "value": "CloudSyncOutlined",
        "name": "云同步"
      },
      {
        "value": "CloudUploadOutlined",
        "name": "云上传"
      },
      {
        "value": "ClusterOutlined",
        "name": "集群"
      },
      {
        "value": "CodeOutlined",
        "name": "代码"
      },
      {
        "value": "CoffeeOutlined",
        "name": "咖啡"
      },
      {
        "value": "CommentOutlined",
        "name": "评论"
      },
      {
        "value": "CompassOutlined",
        "name": "指南针"
      },
      {
        "value": "CompressOutlined",
        "name": "压缩"
      },
      {
        "value": "ConsoleSqlOutlined",
        "name": "SQL控制台"
      },
      {
        "value": "ContactsOutlined",
        "name": "联系人"
      },
      {
        "value": "ContainerOutlined",
        "name": "容器"
      },
      {
        "value": "ControlOutlined",
        "name": "控制"
      },
      {
        "value": "CopyrightCircleOutlined",
        "name": "圆形版权"
      },
      {
        "value": "CopyrightOutlined",
        "name": "版权"
      },
      {
        "value": "CreditCardOutlined",
        "name": "信用卡"
      },
      {
        "value": "CrownOutlined",
        "name": "皇冠"
      },
      {
        "value": "CustomerServiceOutlined",
        "name": "客服"
      },
      {
        "value": "DashboardOutlined",
        "name": "仪表盘"
      },
      {
        "value": "DatabaseOutlined",
        "name": "数据库"
      },
      {
        "value": "DeleteColumnOutlined",
        "name": "删除列"
      },
      {
        "value": "DeleteRowOutlined",
        "name": "删除行"
      },
      {
        "value": "DeliveredProcedureOutlined",
        "name": "已交付"
      },
      {
        "value": "DeploymentUnitOutlined",
        "name": "部署单元"
      },
      {
        "value": "DesktopOutlined",
        "name": "桌面"
      },
      {
        "value": "DingtalkOutlined",
        "name": "钉钉"
      },
      {
        "value": "DisconnectOutlined",
        "name": "断开连接"
      },
      {
        "value": "DislikeOutlined",
        "name": "不喜欢"
      },
      {
        "value": "DollarCircleOutlined",
        "name": "圆形美元"
      },
      {
        "value": "DollarOutlined",
        "name": "美元"
      },
      {
        "value": "DownloadOutlined",
        "name": "下载"
      },
      {
        "value": "EllipsisOutlined",
        "name": "省略号"
      },
      {
        "value": "EnvironmentOutlined",
        "name": "环境"
      },
      {
        "value": "EuroCircleOutlined",
        "name": "圆形欧元"
      },
      {
        "value": "EuroOutlined",
        "name": "欧元"
      },
      {
        "value": "ExceptionOutlined",
        "name": "异常"
      },
      {
        "value": "ExpandAltOutlined",
        "name": "展开"
      },
      {
        "value": "ExpandOutlined",
        "name": "扩展"
      },
      {
        "value": "ExperimentOutlined",
        "name": "实验"
      },
      {
        "value": "ExportOutlined",
        "name": "导出"
      },
      {
        "value": "EyeOutlined",
        "name": "查看"
      },
      {
        "value": "EyeInvisibleOutlined",
        "name": "隐藏"
      },
      {
        "value": "FieldBinaryOutlined",
        "name": "二进制字段"
      },
      {
        "value": "FieldNumberOutlined",
        "name": "数字字段"
      },
      {
        "value": "FieldStringOutlined",
        "name": "字符串字段"
      },
      {
        "value": "FieldTimeOutlined",
        "name": "时间字段"
      },
      {
        "value": "FileAddOutlined",
        "name": "新建文件"
      },
      {
        "value": "FileDoneOutlined",
        "name": "完成文件"
      },
      {
        "value": "FileExcelOutlined",
        "name": "Excel文件"
      },
      {
        "value": "FileExclamationOutlined",
        "name": "异常文件"
      },
      {
        "value": "FileOutlined",
        "name": "文件"
      },
      {
        "value": "FileGifOutlined",
        "name": "GIF文件"
      },
      {
        "value": "FileImageOutlined",
        "name": "图片文件"
      },
      {
        "value": "FileJpgOutlined",
        "name": "JPG文件"
      },
      {
        "value": "FileMarkdownOutlined",
        "name": "Markdown文件"
      },
      {
        "value": "FilePdfOutlined",
        "name": "PDF文件"
      },
      {
        "value": "FilePptOutlined",
        "name": "PPT文件"
      },
      {
        "value": "FileProtectOutlined",
        "name": "文件保护"
      },
      {
        "value": "FileSearchOutlined",
        "name": "搜索文件"
      },
      {
        "value": "FileSyncOutlined",
        "name": "同步文件"
      },
      {
        "value": "FileTextOutlined",
        "name": "文本文件"
      },
      {
        "value": "FileUnknownOutlined",
        "name": "未知文件"
      },
      {
        "value": "FileWordOutlined",
        "name": "Word文件"
      },
      {
        "value": "FileZipOutlined",
        "name": "压缩文件"
      },
      {
        "value": "FilterOutlined",
        "name": "筛选"
      },
      {
        "value": "FireOutlined",
        "name": "火焰"
      },
      {
        "value": "FlagOutlined",
        "name": "旗帜"
      },
      {
        "value": "FolderAddOutlined",
        "name": "新建文件夹"
      },
      {
        "value": "FolderOutlined",
        "name": "文件夹"
      },
      {
        "value": "FolderOpenOutlined",
        "name": "打开文件夹"
      },
      {
        "value": "FolderViewOutlined",
        "name": "查看文件夹"
      },
      {
        "value": "ForkOutlined",
        "name": "分支"
      },
      {
        "value": "FormatPainterOutlined",
        "name": "格式刷"
      },
      {
        "value": "FrownOutlined",
        "name": "不高兴"
      },
      {
        "value": "FunctionOutlined",
        "name": "函数"
      },
      {
        "value": "FundProjectionScreenOutlined",
        "name": "基金投影"
      },
      {
        "value": "FundViewOutlined",
        "name": "基金视图"
      },
      {
        "value": "FunnelPlotOutlined",
        "name": "漏斗图"
      },
      {
        "value": "GatewayOutlined",
        "name": "网关"
      },
      {
        "value": "GifOutlined",
        "name": "GIF"
      },
      {
        "value": "GiftOutlined",
        "name": "礼物"
      },
      {
        "value": "GlobalOutlined",
        "name": "全球"
      },
      {
        "value": "GoldOutlined",
        "name": "金币"
      },
      {
        "value": "GroupOutlined",
        "name": "组"
      },
      {
        "value": "HddOutlined",
        "name": "硬盘"
      },
      {
        "value": "HeartOutlined",
        "name": "心形"
      },
      {
        "value": "HistoryOutlined",
        "name": "历史"
      },
      {
        "value": "HolderOutlined",
        "name": "占位符"
      },
      {
        "value": "HomeOutlined",
        "name": "主页"
      },
      {
        "value": "HourglassOutlined",
        "name": "沙漏"
      },
      {
        "value": "IdcardOutlined",
        "name": "身份证"
      },
      {
        "value": "ImportOutlined",
        "name": "导入"
      },
      {
        "value": "InboxOutlined",
        "name": "收件箱"
      },
      {
        "value": "InsertRowAboveOutlined",
        "name": "向上插入行"
      },
      {
        "value": "InsertRowBelowOutlined",
        "name": "向下插入行"
      },
      {
        "value": "InsertRowLeftOutlined",
        "name": "向左插入行"
      },
      {
        "value": "InsertRowRightOutlined",
        "name": "向右插入行"
      },
      {
        "value": "InsuranceOutlined",
        "name": "保险"
      },
      {
        "value": "InteractionOutlined",
        "name": "交互"
      },
      {
        "value": "KeyOutlined",
        "name": "钥匙"
      },
      {
        "value": "LaptopOutlined",
        "name": "笔记本"
      },
      {
        "value": "LayoutOutlined",
        "name": "布局"
      },
      {
        "value": "LikeOutlined",
        "name": "喜欢"
      },
      {
        "value": "LineOutlined",
        "name": "线条"
      },
      {
        "value": "LinkOutlined",
        "name": "链接"
      },
      {
        "value": "Loading3QuartersOutlined",
        "name": "加载中"
      },
      {
        "value": "LockOutlined",
        "name": "锁定"
      },
      {
        "value": "MacCommandOutlined",
        "name": "Mac命令"
      },
      {
        "value": "MailOutlined",
        "name": "邮件"
      },
      {
        "value": "ManOutlined",
        "name": "男性"
      },
      {
        "value": "MedicineBoxOutlined",
        "name": "医药箱"
      },
      {
        "value": "MehOutlined",
        "name": "一般"
      },
      {
        "value": "MenuOutlined",
        "name": "菜单"
      },
      {
        "value": "MergeCellsOutlined",
        "name": "合并单元格"
      },
      {
        "value": "MessageOutlined",
        "name": "消息"
      },
      {
        "value": "MobileOutlined",
        "name": "手机"
      },
      {
        "value": "MoneyCollectOutlined",
        "name": "收钱"
      },
      {
        "value": "MonitorOutlined",
        "name": "显示器"
      },
      {
        "value": "MoreOutlined",
        "name": "更多"
      },
      {
        "value": "NodeCollapseOutlined",
        "name": "节点折叠"
      },
      {
        "value": "NodeExpandOutlined",
        "name": "节点展开"
      },
      {
        "value": "NodeIndexOutlined",
        "name": "节点索引"
      },
      {
        "value": "NotificationOutlined",
        "name": "通知"
      },
      {
        "value": "NumberOutlined",
        "name": "数字"
      },
      {
        "value": "OneToOneOutlined",
        "name": "一对一"
      },
      {
        "value": "PaperClipOutlined",
        "name": "回形针"
      },
      {
        "value": "PartitionOutlined",
        "name": "分区"
      },
      {
        "value": "PayCircleOutlined",
        "name": "圆形支付"
      },
      {
        "value": "PercentageOutlined",
        "name": "百分比"
      },
      {
        "value": "PhoneOutlined",
        "name": "电话"
      },
      {
        "value": "PictureOutlined",
        "name": "图片"
      },
      {
        "value": "PlaySquareOutlined",
        "name": "方形播放"
      },
      {
        "value": "PoundCircleOutlined",
        "name": "圆形英镑"
      },
      {
        "value": "PoundOutlined",
        "name": "英镑"
      },
      {
        "value": "PoweroffOutlined",
        "name": "关机"
      },
      {
        "value": "PrinterOutlined",
        "name": "打印机"
      },
      {
        "value": "ProfileOutlined",
        "name": "资料"
      },
      {
        "value": "ProjectOutlined",
        "name": "项目"
      },
      {
        "value": "PropertySafetyOutlined",
        "name": "财产安全"
      },
      {
        "value": "PullRequestOutlined",
        "name": "拉取请求"
      },
      {
        "value": "PushpinOutlined",
        "name": "图钉"
      },
      {
        "value": "QrcodeOutlined",
        "name": "二维码"
      },
      {
        "value": "ReadOutlined",
        "name": "阅读"
      },
      {
        "value": "ReconciliationOutlined",
        "name": "对账"
      },
      {
        "value": "RedEnvelopeOutlined",
        "name": "红包"
      },
      {
        "value": "ReloadOutlined",
        "name": "刷新"
      },
      {
        "value": "RestOutlined",
        "name": "休息"
      },
      {
        "value": "RobotOutlined",
        "name": "机器人"
      },
      {
        "value": "RocketOutlined",
        "name": "火箭"
      },
      {
        "value": "RotateLeftOutlined",
        "name": "向左旋转"
      },
      {
        "value": "RotateRightOutlined",
        "name": "向右旋转"
      },
      {
        "value": "SafetyCertificateOutlined",
        "name": "安全证书"
      },
      {
        "value": "SafetyOutlined",
        "name": "安全"
      },
      {
        "value": "SaveOutlined",
        "name": "保存"
      },
      {
        "value": "ScanOutlined",
        "name": "扫描"
      },
      {
        "value": "ScheduleOutlined",
        "name": "日程表"
      },
      {
        "value": "SearchOutlined",
        "name": "搜索"
      },
      {
        "value": "SecurityScanOutlined",
        "name": "安全扫描"
      },
      {
        "value": "SelectOutlined",
        "name": "选择"
      },
      {
        "value": "SendOutlined",
        "name": "发送"
      },
      {
        "value": "SettingOutlined",
        "name": "设置"
      },
      {
        "value": "ShakeOutlined",
        "name": "抖动"
      },
      {
        "value": "ShareAltOutlined",
        "name": "分享"
      },
      {
        "value": "ShopOutlined",
        "name": "商店"
      },
      {
        "value": "ShoppingCartOutlined",
        "name": "购物车"
      },
      {
        "value": "ShoppingOutlined",
        "name": "购物"
      },
      {
        "value": "SisternodeOutlined",
        "name": "姊妹节点"
      },
      {
        "value": "SkinOutlined",
        "name": "皮肤"
      },
      {
        "value": "SmileOutlined",
        "name": "微笑"
      },
      {
        "value": "SolutionOutlined",
        "name": "解决方案"
      },
      {
        "value": "SoundOutlined",
        "name": "声音"
      },
      {
        "value": "SplitCellsOutlined",
        "name": "拆分单元格"
      },
      {
        "value": "StarOutlined",
        "name": "星星"
      },
      {
        "value": "SubnodeOutlined",
        "name": "子节点"
      },
      {
        "value": "SwitcherOutlined",
        "name": "切换器"
      },
      {
        "value": "SyncOutlined",
        "name": "同步"
      },
      {
        "value": "TableOutlined",
        "name": "表格"
      },
      {
        "value": "TabletOutlined",
        "name": "平板"
      },
      {
        "value": "TagOutlined",
        "name": "标签"
      },
      {
        "value": "TagsOutlined",
        "name": "标签组"
      },
      {
        "value": "TeamOutlined",
        "name": "团队"
      },
      {
        "value": "ThunderboltOutlined",
        "name": "闪电"
      },
      {
        "value": "ToTopOutlined",
        "name": "返回顶部"
      },
      {
        "value": "ToolOutlined",
        "name": "工具"
      },
      {
        "value": "TrademarkCircleOutlined",
        "name": "圆形商标"
      },
      {
        "value": "TrademarkOutlined",
        "name": "商标"
      },
      {
        "value": "TransactionOutlined",
        "name": "交易"
      },
      {
        "value": "TranslationOutlined",
        "name": "翻译"
      },
      {
        "value": "TrophyOutlined",
        "name": "奖杯"
      },
      {
        "value": "UngroupOutlined",
        "name": "取消组合"
      },
      {
        "value": "UnlockOutlined",
        "name": "解锁"
      },
      {
        "value": "UploadOutlined",
        "name": "上传"
      },
      {
        "value": "UsbOutlined",
        "name": "USB"
      },
      {
        "value": "UserAddOutlined",
        "name": "添加用户"
      },
      {
        "value": "UserDeleteOutlined",
        "name": "删除用户"
      },
      {
        "value": "UserOutlined",
        "name": "用户"
      },
      {
        "value": "UserSwitchOutlined",
        "name": "切换用户"
      },
      {
        "value": "UsergroupAddOutlined",
        "name": "添加用户组"
      },
      {
        "value": "UsergroupDeleteOutlined",
        "name": "删除用户组"
      },
      {
        "value": "VerifiedOutlined",
        "name": "已验证"
      },
      {
        "value": "VideoCameraAddOutlined",
        "name": "添加视频"
      },
      {
        "value": "VideoCameraOutlined",
        "name": "视频"
      },
      {
        "value": "WalletOutlined",
        "name": "钱包"
      },
      {
        "value": "WhatsAppOutlined",
        "name": "WhatsApp"
      },
      {
        "value": "WifiOutlined",
        "name": "WiFi"
      },
      {
        "value": "WomanOutlined",
        "name": "女性"
      }
    ]
  }
]